import { urlBaseAccreditation } from "../../config/";
import axiosInstance from "../../../services/config/axiosinstance";

export default async function getGuestSchedulesPassCount(
  eventId = '',
  search = '',
  limit = 10,
  offset = 0,
) {
  try {
    const _config = {
      method: 'GET',
      url: `${urlBaseAccreditation}/report/getGuestSchedulesPassCount?eventId=${eventId}&offset=${offset}&limit=${limit}`
        + (search ? `&search=${encodeURIComponent(search)}` : ''),
      headers: {
        "Content-Type": "application/json",
      },
    };
    const _ret = await axiosInstance(_config);

    if (!_ret.data.success) {
      throw new Error(_ret.data.message);
    }

    return _ret.data.data;
  } catch (error) {
    console.log('Error getGuestSchedulesPassCount', error);
    throw error;
  }
}
